import imageOne from '@/assets/images/cities/hamilton1.jpg'
import imageTwo from '@/assets/images/cities/hamilton2.jpg'
import imageThree from '@/assets/images/cities/hamilton3.jpg'

export default {
  imageOne,
  imageTwo,
  imageThree,
  city: 'Hamilton',
  writeup: '',
  website: 'HamiltonNotary.com',
  url: 'https://www.hamiltonnotary.com/',
  notaries: [
    {
      name: 'Hamilton',
      open: true,
      phone: '(289) 975-4566',
      hours: {
        monday: '10:00AM to 7:00PM',
        tuesday: '10:00AM to 7:00PM',
        wednesday: '10:00AM to 7:00PM',
        thursday: '10:00AM to 7:00PM',
        friday: '10:00AM to 7:00PM',
        saturday: '10:00AM to 7:00PM',
        sunday: '10:00AM to 7:00PM'
      },
      address: 'Stone Church Road East Location',
      notes: ''
    },
    {
      name: 'Waterdown',
      open: true,
      phone: '(289) 975-4566',
      hours: {
        monday: '8:00AM to 6:00PM',
        tuesday: '8:00AM to 6:00PM',
        wednesday: '8:00AM to 6:00PM',
        thursday: '8:00AM to 6:00PM',
        friday: '8:00AM to 6:00PM',
        saturday: 'By Request',
        sunday: 'By Request'
      },
      address: 'Beeforth Road Location',
      notes: ''
    }
  ]
}



// WEBPACK FOOTER //
// ./src/store/provinces/ontario/cities/hamilton.js